import * as React from "react";
import { MenuList } from "../menus/layout/list";
import { MenuListButton } from "../menus/layout/button";
import { MenuListItem } from "../menus/layout/item";
import shortid from "shortid";
import cloneDeep from "lodash/cloneDeep";
import { Modal } from "@lib/components";
import { ModalContent } from "@lib/components";
import { Button } from "@lib/components";
import { RotateLoader } from "@lib/components";
import { DragDropContext, DropResult } from "react-beautiful-dnd";
import { arrayMove } from "react-sortable-hoc";
import { RestaurantFormDishTags } from "../menus/forms/tags";
import { inject, observer } from "mobx-react";
import { MobxComponent } from "../../../../../mobx/components";
import { isMobile } from 'react-device-detect';
import { RestaurantFormMobileDishTags } from "../menus/forms/mobileForms/mobileTags";
import { MenuListItemV2 } from "./item-v2";
import { TabGroup, TabItem } from "../settings-v2/receipt-printing";
import { ItemTags } from "./item-tags";
import { UI } from "../../../../../core/ui";

import { getTagId } from "../menus/utils/sortLists";

interface Props {}
interface State {
	reorder: boolean;
	index_copy: number | null;
	index_panel: number | null;
	index_remove: number | null;

	loading_copy: boolean;
	loading_remove: boolean;
	loading_reorder: boolean;
}

@inject("store")
@observer
export class RestaurantDishTagsV2 extends MobxComponent<Props, State> {
	backup: T.Schema.Restaurant.RestaurantSchema["dish_tags"] | null;

	constructor(props: Props) {
		super(props);
		this.state = {
			reorder: false,
			index_copy: null,
			index_panel: null,
			index_remove: null,
			loading_copy: false,
			loading_remove: false,
			loading_reorder: false,
		};
		this.backup = null;
	}

	componentDidMount() {
		const r = this.injected.store.restaurant!;
		if (this.injected.store.isNewMenuSchema && (!r.dish_tags || r.dish_tags.length === 0)) {
			this.injected.store.api.tags_list(r._id!).then((res: any) => {
				if (res?.tags && Array.isArray(res.tags)) {
					const tags = (res.tags as any[]).map((t: any) => ({
						_id: t.id || t._id,
						name: t.name ?? '',
						type: (t.type ?? 'none') as 'icon' | 'text' | 'none',
						text: t.text ?? '',
						icon: t.icon ?? '',
						color: t.color ?? { icon: { background: '#fff', text: '#ff7d4b' }, wrapper: { background: '#ff7d4b', text: '#fff' } },
					}));
					this.injected.store.updateRestaurant({ dish_tags: tags });
				}
			}).catch(() => {});
		}
	}

	componentWillUnmount() {
		if (this.state.reorder) {
			this.reorder_cancel();
		}
	}

	create_item = (): T.Schema.Restaurant.Menu.RestaurantDishTag => {
		return {
			_id: shortid.generate(),
			name: "",
			type: "none",
			text: "Example",
			icon: "",
			color: {
				icon: {
					background: "#fff",
					text: "#ff7d4b",
				},
				wrapper: {
					background: "#ff7d4b",
					text: "#fff",
				},
			},
		};
	};

	list_item = () => {
		const { reorder, loading_reorder } = this.state;
		const r = this.injected.store.restaurant!;
		const dish_tags = r.dish_tags ?? [];
        const { store } = this.injected;
        const { setActiveMobileMenu } = store;
       return (
			<>
				<MenuList id="dish-tag-list" type="DISHTAG">
					{/* @ts-ignore */}
					{dish_tags.map((item, i) => {
						const tagId = getTagId(item);
						const originalIndex = (r.dish_tags ?? []).findIndex(
							(tag) => getTagId(tag) === tagId
						);
						return (
							<MenuListItemV2
								key={tagId || `item-tag-${i}`}
								type="DISHTAG"
								id={tagId || `item-tag-${i}`}
								mode={reorder ? "reOrder" : "normal"}
								name={item.name}
								index={reorder ? i : originalIndex}
								onEdit={() =>   {
									setActiveMobileMenu('edit-dish-tag', 'menus', originalIndex)
								}}
								onRemove={() => this.modal_remove_open(originalIndex)}
								onCopy={() => this.modal_copy_open(originalIndex)}
							/>
						);
					})}
				</MenuList>

				{!reorder && (
                    <TabGroup className='menus menus-end menus-header' style={{ overflow: 'unset', marginBottom: '50px'}}>
                     		<TabItem
								className="footer-button"
                     			onClick={() => {
                     				setActiveMobileMenu('create-dish-tag', 'menus')
                     			}}
								style={{ height: '43px'}}>
                     			Create New Item Tags
                     		</TabItem>
                     		<TabItem
								className="footer-button"
                                onClick={this.reorder_start}
								style={{ height: '43px'}}>
                     			Re-Arrange
                     		</TabItem>
                        
                     	</TabGroup>
				)}

				{reorder && (
					<>
						<div className="grid-2 xs xs-gap m-t-10">
							<div className="col">
								<MenuListButton onClick={this.reorder_save}>
									{loading_reorder && (
										<RotateLoader size={2} color="white" />
									)}
									{!loading_reorder && "Save"}
								</MenuListButton>
							</div>
							<div className="col">
								<MenuListButton onClick={this.reorder_cancel}>
									Cancel
								</MenuListButton>
							</div>
						</div>
						<div className="text-center m-t-3">
							<p>
								Click + hold to drag and drop items to re-order
								them
							</p>
						</div>
					</>
				)}
			</>
		);
	};

	panel_set = (index_panel: number | null) => {
		this.setState({ index_panel });
	};
	panel_create = () => {
		const r = this.injected.store.restaurant!;
		const { index_panel } = this.state;

		let initialValues = null;
		if (index_panel !== null) {
			if (index_panel === -1) {
				initialValues = this.create_item();
			} else {
				const item = r.dish_tags[index_panel];
				initialValues = cloneDeep(item);
			}
		}

		return isMobile ? (
			<RestaurantFormMobileDishTags
				type={index_panel === -1 ? "create" : "edit"}
				initialValues={initialValues}
				close={() => this.panel_set(null)}
			/>
		) : (
			<RestaurantFormDishTags
				type={index_panel === -1 ? "create" : "edit"}
				initialValues={initialValues}
				close={() => this.panel_set(null)}
			/>
		);
	};

	copy = async (index: number) => {
		const { store } = this.injected;
		const r = store.restaurant!;
		if (this.injected.store.isNewMenuSchema) {
			const dish_tag = cloneDeep(r.dish_tags[index]);
			dish_tag.name = `${dish_tag.name} - Copy`;
			const created = await store.api.tags_create({ restaurant_id: r._id!, data: { ...dish_tag } });
			const newId = (created as any)?.tag?.id ?? (created as any)?.id ?? (created as any)?.data?.id;
			if (newId) {
				const next = [...r.dish_tags];
				next.splice(index + 1, 0, dish_tag);
				store.updateRestaurant({ dish_tags: next });
				this.modal_copy_close();
				UI.notification.success('Tag copied');
				return
			}
		}
		await this.saveRestaurant({
			successMsg: "Tag copied",
			process: (r) => {
				const dish_tag = cloneDeep(r.dish_tags[index]);
				dish_tag._id = shortid.generate();
				dish_tag.name = `${dish_tag.name} - Copy`;
				r.dish_tags.splice(index + 1, 0, dish_tag);
				return {
					update: { $set: { dish_tags: r.dish_tags } },
				};
			},
			before: () => this.setState({ loading_copy: true }),
			onSuccess: () => this.modal_copy_close(),
			onFail: () => this.setState({ loading_copy: false }),
			onError: () => this.setState({ loading_copy: false }),
		});
	};
	remove = async (index: number) => {
		const r = this.injected.store.restaurant!;
		if (this.injected.store.isNewMenuSchema) {
			this.setState({ loading_remove: true });
			const tag = r.dish_tags[index];
			const tagId = (tag as any)?.id ?? tag?._id;
			if (!tagId) {
				this.setState({ loading_remove: false });
				return;
			}
			try {
				await this.injected.store.api.tags_delete({ restaurant_id: r._id!, tag_id: tagId });
				const next = (r.dish_tags || []).filter((_, i) => i !== index);
				this.injected.store.updateRestaurant({ dish_tags: next });
				UI.notification.success('Tag deleted');
				this.modal_remove_close();
			} catch (e: any) {
				UI.notification.error(e?.message ?? 'Failed to delete tag');
			}
			this.setState({ loading_remove: false });
			return;
		}
		await this.saveRestaurant({
			successMsg: "Tag deleted",
			process: (r) => {
				r.dish_tags.splice(index, 1);
				return {
					update: { $set: { dish_tags: r.dish_tags } },
				};
			},
			before: () => this.setState({ loading_remove: true }),
			onSuccess: () => this.modal_remove_close(),
			onFail: () => this.setState({ loading_remove: false }),
			onError: () => this.setState({ loading_remove: false }),
		});
	};

	modal_copy_open = (index: number | null) => {
		this.setState({
			index_copy: index,
			loading_copy: false,
		});
	};
	modal_copy_close = () => {
		this.setState({
			index_copy: null,
			loading_copy: false,
		});
	};
	modal_remove_open = (index: number | null) => {
		this.setState({
			index_remove: index,
			loading_remove: false,
		});
	};
	modal_remove_close = () => {
		this.setState({
			index_remove: null,
			loading_remove: false,
		});
	};

	modal_copy = () => {
		const r = this.injected.store.restaurant!;
		const { index_copy, loading_copy } = this.state;

		let item;
		let fn;
		if (index_copy !== null) {
			item = r.dish_tags[index_copy];
			fn = () => this.copy(index_copy);
		}

		return (
			<Modal
				width="sm"
				close={this.modal_copy_close}
				closeButton={false}
				active={!!item}
			>
				<ModalContent className="flex-l-r-center">
					<h4 className="">Copy Item Tag</h4>
					<p className="big underline">{item && item.name}</p>
				</ModalContent>
				<ModalContent className="flex-right">
					<Button
						type="button"
						className="m-r-2 width100 max100px"
						onClick={this.modal_copy_close}
					>
						Cancel
					</Button>
					<Button
						type="button"
						className="width100 max100px"
						color="primary"
						onClick={fn}
					>
						{loading_copy && (
							<RotateLoader size={2} color="white" />
						)}
						{!loading_copy && "Copy"}
					</Button>
				</ModalContent>
			</Modal>
		);
	};
	modal_remove = () => {
		const r = this.injected.store.restaurant!;
		const { index_remove, loading_remove } = this.state;

		let item;
		let fn;
		if (index_remove !== null) {
			item = r.dish_tags[index_remove];
			fn = () => this.remove(index_remove);
		}

		return (
			<Modal
				width="sm"
				close={this.modal_remove_close}
				closeButton={false}
				active={!!item}
			>
				<ModalContent className="flex-l-r-center">
					<h4 className="">Delete Dish Tag</h4>
					<p className="big underline">{item && item.name}</p>
				</ModalContent>
				<ModalContent className="flex-right">
					<Button
						type="button"
						className="m-r-2 width100 max100px"
						onClick={this.modal_remove_close}
					>
						Cancel
					</Button>
					<Button
						type="button"
						className="width100 max100px"
						color="primary"
						onClick={fn}
					>
						{loading_remove && (
							<RotateLoader size={2} color="white" />
						)}
						{!loading_remove && "Delete"}
					</Button>
				</ModalContent>
			</Modal>
		);
	};

	reorder_start = () => {
		this.setState({ reorder: true });
		const tags = this.injected.store.restaurant!.dish_tags;
		this.backup = cloneDeep(Array.isArray(tags) ? tags : []);
	};

	reorder_cancel = () => {
		this.injected.store.updateRestaurant({
			dish_tags: this.backup ?? [],
		});
		this.setState({ reorder: false });
		this.backup = null;
	};

	reorder_save = async () => {
		const r = this.injected.store.restaurant!;
		const tags = r.dish_tags ?? [];

		if (this.injected.store.isNewMenuSchema) {
			this.setState({ loading_reorder: true });
			try {
				const order = tags.map((tag) => (tag as any)?.id ?? tag?._id).filter(Boolean) as string[];
				if (order.length > 0) {
					await this.injected.store.api.tags_order({
						restaurant_id: r._id!,
						order,
					});
				}
				UI.notification.success('Tags re-arranged');
				this.setState({ reorder: false, loading_reorder: false });
				this.backup = null;
			} catch (e: any) {
				UI.notification.error(e?.message ?? 'Failed to save order');
				this.setState({ loading_reorder: false });
			}
			return;
		}

		const backup = cloneDeep(r);
		if (this.backup) backup.dish_tags = this.backup;
		await this.saveRestaurantSilent({
			backup: backup,
			update: { $set: { dish_tags: tags } },
			successMsg: "Tags re-arranged",
			before: () => this.setState({ loading_reorder: true }),
			onSuccess: () => {
				this.setState({ reorder: false, loading_reorder: false });
				this.backup = null;
			},
			onFail: () => this.setState({ loading_reorder: false }),
			onError: () => this.setState({ loading_reorder: false }),
		});
	};

	onDragEnd = (result: DropResult) => {
		const { destination, source } = result;
		if (!destination || destination.index === source.index) return;
		const r = this.injected.store.restaurant!;
		const current = r.dish_tags ?? [];
		if (source.index < 0 || source.index >= current.length || destination.index < 0 || destination.index >= current.length) return;
		const next = arrayMove(current, source.index, destination.index);
		this.injected.store.updateRestaurant({ dish_tags: next });
	};

	render() {
        const { store } = this.injected;
        const { activeMobileMenu } = store;
        return (
            (activeMobileMenu.name == 'create-dish-tag' || 
            activeMobileMenu.name == 'edit-dish-tag')  ? 
                <ItemTags selectedTagIndex={activeMobileMenu.data} />	
			:<DragDropContext onDragEnd={this.onDragEnd}>
				{this.list_item()}
				{this.modal_copy()}
				{this.modal_remove()}
            </DragDropContext> 
		);
	}
}
